// apolo/src/components/code/chat/CanvasPanel.jsx — Fase 1 · E8 (Canvas).
//
// Superfície de trabalho INLINE no chat (coluna direita), reusando os tabs do
// SidePanel (Preview/Diff/Files/Terminal) — os Componentes são standalone, então
// renderizamos direto, sem o chrome de drawer. O toggle Saídas|Canvas e a largura
// vivem no SessionWorkspace. `apolo:openDiff` (Revisar/Abrir) seleciona a aba Diff.
//
// O refactor completo (ResponsivePanel unificando rail + drawer + canvas) fica
// pra depois; aqui reusamos o que já existe, sem duplicar os tabs.

import { useEffect, useState } from 'react';
import { SIDE_PANEL_TABS } from '../SidePanel.jsx';

const CANVAS_TAB_IDS = ['diff', 'preview', 'files', 'terminal'];
const CANVAS_TABS = CANVAS_TAB_IDS
  .map((id) => SIDE_PANEL_TABS.find((t) => t.id === id))
  .filter(Boolean);

export default function CanvasPanel({ sessionId }) {
  const [active, setActive] = useState('diff');

  // Revisar/Abrir num artefato → foca a aba Diff dentro do Canvas.
  useEffect(() => {
    function onOpenDiff() {
      setActive('diff');
    }
    window.addEventListener('apolo:openDiff', onOpenDiff);
    return () => window.removeEventListener('apolo:openDiff', onOpenDiff);
  }, []);

  const tab = CANVAS_TABS.find((t) => t.id === active) ?? CANVAS_TABS[0];
  const Body = tab?.Component;

  return (
    <div className="flex h-full min-h-0 flex-col">
      <div role="tablist" aria-label="Canvas" className="flex shrink-0 items-center gap-0.5 pb-2">
        {CANVAS_TABS.map((t) => {
          const Icon = t.icon;
          const on = t.id === active;
          return (
            <button
              key={t.id}
              type="button"
              role="tab"
              aria-selected={on}
              onClick={() => setActive(t.id)}
              className={`inline-flex items-center gap-1.5 rounded-md px-2.5 py-1 text-[12px] font-medium transition focus:outline-none focus-visible:ring-2 focus-visible:ring-apolo-accent/40 ${
                on
                  ? 'bg-apolo-surface2 text-apolo-textPrimary'
                  : 'text-apolo-textTertiary hover:bg-apolo-surface2/60 hover:text-apolo-textSecondary'
              }`}
            >
              <Icon size={13} aria-hidden="true" />
              {t.label}
            </button>
          );
        })}
      </div>
      <div className="min-h-0 flex-1 overflow-auto">
        {Body ? <Body sessionId={sessionId} /> : null}
      </div>
    </div>
  );
}
